var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document.type == 'page')?_c('Page',{attrs:{"document":this.document,"hreflangs":this.hreflangs}}):(_vm.document.type == 'lender')?_c('Lender',{attrs:{"document":this.document}}):(_vm.document.type == 'credit_card')?_c('CreditCard',{attrs:{"document":this.document}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }